import {
  HTTP_UPDATEAPPROVE_FETCHING,
  HTTP_UPDATEAPPROVE_SUCCESS,
  HTTP_UPDATEAPPROVE_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_UPDATEAPPROVE_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_UPDATEAPPROVE_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_UPDATEAPPROVE_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
